import axios from 'axios'  
  
// server url is empty string in prod cause it's the same server
const SERVER_URL = process.env.NODE_ENV == 'production' ? '' : 'http://localhost:9000';
// const SERVER_URL = 'http://localhost:9000';
console.log(`Mode is ${process.env.NODE_ENV}, SERVER_URL: ${SERVER_URL}`)
const instance = axios.create({  
  baseURL: SERVER_URL,
  timeout: 1000
});  
  
export default {
  // (C)reate
  createNew: (text, completed) => instance.post('/data/points/', {title: text, completed: completed}),
  // (R)ead
  // getAll: () => instance.get('data/points', {
  //   transformResponse: [function (data) {
  //     return data? JSON.parse(data)._embedded.waterPoints : data;
  //   }]
  // }),
  getAllSources: () => instance.get('/data/sources/'),
  getForId: (id) => instance.get('/data/points/'+id),
  // (U)pdate  
  updateForId: (id, text, completed) => instance.put('data/points/'+id, {title: text, completed: completed}),  
  // (D)elete  
  removeForId: (id) => instance.delete('data/points/'+id)  
}